import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import { RootState } from "../redux/store";
import { useEffect, useMemo, useState } from "react";
import { SchoolAccountState, SchoolUserAccountState, SchoolUserAuthority } from "../firebase/types-school";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import { TabNames } from "./type";
import { auth } from "../firebase/configs";
import { FieldState, TeacherAccountState } from "../firebase/types-teacher";
import { isObjectEmpty } from "../firebase/general-apis";
import { getDatabase, onValue, ref } from "firebase/database";
import { Modal, Stack } from "@mui/material";
import { GeneralDialog } from "../components/AlertComponent/Dialog";

interface IRoute {
  children: JSX.Element;
  customizedFallbackRoute?: string;
}

export function AuthRoute({ children, customizedFallbackRoute }: IRoute) {
  const userId = useSelector((state: RootState) => state.user.userId);

  if(userId === undefined) return <LoadingSpinner fillViewPortHeight fillViewPortWidth/>

  return userId !== null ? (
    <Navigate to={`${customizedFallbackRoute ?? "/"}`} replace />
  ) : (
    children
  );
}

export const VerifyWrapper = ({ children }: IRoute) => {
  const user = useSelector((state: RootState) => state.user.user);

  if(user === undefined || !auth.currentUser) return (<LoadingSpinner/>)

  if(user === null) { return <Navigate to={`/${TabNames.LOGIN}`} replace/>}

  // if(localStorage.getItem('payslipReq') !== null) {
  //   <Navigate to={`/${TabNames.PAYSLIP_API}/${localStorage.getItem('payslipReq')}`} />
  // }

  return auth.currentUser.emailVerified ? 
    <Navigate to={`/${TabNames.DASHBOARD}`} replace/>
  : children
}

export function DashboardRoute({ children, customizedFallbackRoute }: IRoute) {
  const userDelete = useSelector((state: RootState) => state.userReg.userDelete);
  const sessionLogout = useSelector((state: RootState) => state.user.sessionLogout);
  const user = useSelector((state: RootState) => state.user.user);
  
  const empSettingExists = useSelector((state: RootState) => state.userReg.employmentSettingExists);
  const fbConnection = useSelector((state: RootState) => state.ui.fbStatus);
  const navigate = useNavigate();


  if (user === undefined) {
    return <></>
  }
  
  if(user === null) {
    if(userDelete || sessionLogout) {
      return children;
    }
    return <Navigate to={customizedFallbackRoute || `/`} replace />
  }


  if(!fbConnection) {
    return (
      <Stack sx={{height: '100vh', width: '100vw'}}>
        <GeneralDialog visible={true} title="Network Error" desc={<>It appears that the network you are connected to is blocking access to our server.<br/><br/>Please disconnect from the Wi-Fi network and try again.</>} onConfirm={() => navigate('/')}/>
      </Stack>
    )
  }

  if ((user.accountType === undefined) || (user.accountType === 'teacher' && empSettingExists !== undefined && empSettingExists === false)) {
    return <Navigate to={`/${TabNames.CHOOSE_ACC_TYPE}`} replace />
  }

  if(auth.currentUser && !auth.currentUser.emailVerified) {
    return <Navigate to={`/${TabNames.VERIFY_EMAIL}`} replace/>
  }

  return children;

  // return userDelete || sessionLogout ? (
  //   children
  // ) : (
  //   <Navigate to={`${customizedFallbackRoute ?? `/${TabNames.LOGIN}`}`} replace />
  // );
}

export const SchoolPermissionRoute = ({ children, customizedFallbackRoute }: IRoute) => {
  const schoolId = useSelector((state: RootState) => state.school.schoolId);
  const school = useSelector((state: RootState) => state.school.school);
  const schoolUser = useSelector((state: RootState) => state.school.schoolUser);
  
  const canAccessMySchool = useMemo(() => {
    if (!schoolId || !school?.account?.state || !schoolUser.school?.accountState || !schoolUser.school?.authority) return undefined;
    switch (school?.account?.state as SchoolAccountState) {
      case SchoolAccountState.APPROVED: case SchoolAccountState.PENDING: {
        if (schoolUser.school?.accountState === SchoolUserAccountState.APPROVED || schoolUser.school?.authority === SchoolUserAuthority.ADMIN) {
          return true;
        }
        return false;
      }
      case SchoolAccountState.REMOVED: {
        return false;
      }
      default: return false;
    }
  }, [school?.account?.state, schoolUser.school?.accountState, schoolUser.school?.authority])
  return canAccessMySchool === undefined ?
    <LoadingSpinner />
    :
    canAccessMySchool ?
      children
      :
      <Navigate to={`${customizedFallbackRoute ?? "/"}`} replace />
}

export const PreempDocRoute = ({children}: IRoute) => {
  const accountState = useSelector((state: RootState) => state.userReg.fields.accountState?.value);

  if([TeacherAccountState.INCOMPLETE, TeacherAccountState.SUBMITTED, TeacherAccountState.REJECTED].includes((accountState || FieldState.INCOMPLETE) as TeacherAccountState)) {
    return children
  } else {
    <Navigate to={`/${TabNames.DASHBOARD}`}/>
  }
  
}